module.exports = __webpack_public_path__ + "img/KOSTR.b4a03c2e.png";